/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { mobileOrderItemSizeSchema } from "./mobileOrderItemSizeSchema.ts";
import { portionNutritionSchema } from "./portionNutritionSchema.ts";

export const mobileOrderItemModifierSchema = z.object({
	id: z.uuid(),
	product_id: z.uuid(),
	name: z.string().nullable(),
	amount: z.int().min(-2147483648).max(2147483647).optional(),
	free_amount: z.int().min(0).max(2147483647).optional(),
	price: z.number(),
	total_new_price: z.number(),
	size: mobileOrderItemSizeSchema.nullable(),
	image_link: z.string().nullable(),
	nutrition: portionNutritionSchema.nullable().describe("Вес и КБЖУ порции"),
	delta_price: z
		.string()
		.regex(/^-?\d{0,8}(?:\.\d{0,2})?$/)
		.optional(),
});
